export default {
    url: 'ecocredits-day',
    include: ['us', 'za', 'kr', 'au', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'ca'],
};
